import React from 'react';
import { I } from '../icons-ds';

export type CheckboxProps = {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  'aria-label'?: string;
};

export function Checkbox({ checked, onChange, disabled, ...rest }: CheckboxProps) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      disabled={disabled}
      onClick={onChange}
      style={{
        width: 18, height: 18, borderRadius: 5,
        border: `1.5px solid ${checked ? 'var(--accent)' : 'var(--line-strong)'}`,
        background: checked ? 'var(--accent)' : 'transparent',
        color: 'var(--fg-on-accent)',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        transition: 'all var(--dur-fast) var(--ease-out)',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        padding: 0,
      }}
      {...rest}
    >
      {checked && <I.check size={12} stroke={3} />}
    </button>
  );
}

export default Checkbox;
